import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=3fdd845a&scoped=true"
var script = {}
import style0 from "./Products.vue?vue&type=style&index=0&id=3fdd845a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd845a",
  null
  
)

export default component.exports